module.exports = __webpack_public_path__ + "img/media-folder.9498ac44.svg";